export const getUserFullName = ({
  firstName,
  lastName,
}: User.Data | Company.Member) => `${firstName} ${lastName}`;
